export default "__VITE_ASSET__o_Kf7u1h__"